export default __webpack_public_path__ + "static/N0140-948456bd7de353b520dd4107495164ef.png";